import React from "react";
import { motion } from "framer-motion";

export default function Tagline() {
  return (
    <section
      data-testid="tagline-section"
      className="relative bg-[#FDFBF7] border-b-[3px] border-[#0D0D0D] py-10 px-4 sm:px-6"
    >
      <div className="mx-auto max-w-7xl flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <motion.h2
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-display font-black uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl leading-tight max-w-4xl"
        >
          AI Automation Freelancer
          <span className="mx-3 text-[#FF0055]">|</span>
          Websites, Systems &amp;{" "}
          <span className="relative inline-block">
            <span className="relative z-10 px-2">Growth Tools</span>
            <span className="absolute inset-x-0 bottom-1 h-3 bg-[#FFD800] -z-0" />
          </span>{" "}
          for Local Businesses
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="shrink-0 brut-border brut-shadow-sm bg-[#00E5FF] px-4 py-2 font-mono text-xs uppercase tracking-widest -rotate-2"
        >
          Based in India · Serving worldwide
        </motion.div>
      </div>
    </section>
  );
}
